import React, { Fragment } from 'react'
import BetSlipSider from './BetSlipSider'
import BetSlipBottom from './BetSlipBottom'

const BetSlip: React.FC = props => {
  return (
    <Fragment>
      <BetSlipSider />
      <BetSlipBottom />
    </Fragment>
  )
}

export default BetSlip
